import { createContext, useState } from 'react';
import useFetchOrgLevelSettings from './useFetchOrgLevelSettings';

export const OrgLevelSettingsContext = createContext({
  orgLevelSettings: null,
  setOrgLevelSettings: () => {},
  refetch: false,
  setRefetch: () => {}
});

function NROrgLevelSettingsContextWrapper({ children }) {
  const [orgLevelSettings, setOrgLevelSettings] = useState(null);
  const [refetch, setRefetch] = useState(false);

  useFetchOrgLevelSettings();

  const contextValue = {
    orgLevelSettings,
    setOrgLevelSettings,
    refetch,
    setRefetch
  };

  return <OrgLevelSettingsContext.Provider value={contextValue}>{children}</OrgLevelSettingsContext.Provider>;
}

export default NROrgLevelSettingsContextWrapper;
